import './index.css'
import Button from '../button'
import { useState } from 'react';
import { confirmNewPassword } from '../../functions/confirmNewPassword';

function ConfirmPasswordModule(){
    const [submitted,setSubmitted] = useState(false);
    const [errorMessage,setErrorMessage] = useState("")
    const handleClick = async() => {
        console.log("Change password");
        let resultOfCall = await confirmNewPassword();
        const status = resultOfCall.status;
        console.log(status);
        if(status===200){
            window.location.href="/login"
        }
        else{
            let parsed = await resultOfCall.json();
            setErrorMessage(parsed.message);
        }
    }
    return (
        <div className='reset-password-module'>
            <div className='small-text'>Enter your new password twice below</div>
            <input type='password' id='confirm-new-password1'></input>
            <input type='password' id='confirm-new-password2'></input>
            <Button text="Change password" addedFunction={handleClick} />
            <div id="error-message" className="small-text">{errorMessage}</div>
        </div>
    )
}

export default ConfirmPasswordModule